import { VerifiedIcon } from '@components/Icons';
import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';

interface VerifiedCellProps {
	value: string;
	isVerified: boolean;
	verifiedTitle: string;
	unverifiedTitle: string;
}

const VerifiedCell: React.FC<VerifiedCellProps> = ({
	value,
	isVerified,
	verifiedTitle,
	unverifiedTitle
}) => {
	if (!value) {
		return null;
	}

	return (
		<Box display="flex" flexGrow={1} width="100%" alignItems="end">
			<VerifiedIcon
				verifiedTitle={verifiedTitle}
				isVerified={isVerified}
				unverifiedTitle={unverifiedTitle}
			/>
			<Typography
				textOverflow="ellipsis"
				overflow="hidden"
				title={value}
				variant="body2"
			>
				{value}
			</Typography>
		</Box>
	);
};

export default VerifiedCell;
